module.exports = __webpack_public_path__ + "img/zhongshihua.c997a7a9.jpeg";